// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BoostAddSelectEvent
 */
export var BoostAddSelect = function (_a) {
    var appLocation = _a.appLocation, origin = _a.origin, boostToken = _a.boostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, boostFlowToken = _a.boostFlowToken, referrerFlowToken = _a.referrerFlowToken, currentBoostToken = _a.currentBoostToken, appPresentation = _a.appPresentation, row = _a.row, column = _a.column;
    return ({
        name: "Boost Add Select",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Add",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_token: currentBoostToken !== undefined && currentBoostToken !== null ? currentBoostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_presentation: appPresentation !== undefined && appPresentation !== null ? appPresentation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSelectStartEvent
 *
 * @deprecated Use BoostAddSelect instead.
 */
export var BoostSelectStart = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Select Start",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Select",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSelectCompleteEvent
 *
 * @deprecated Use BoostAddSelect instead.
 */
export var BoostSelectComplete = function (_a) {
    var appLocation = _a.appLocation, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Select Complete",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Select",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostRemoveStartEvent
 *
 * @deprecated Use BoostRemoveSelect instead.
 */
export var BoostRemoveStart = function (_a) {
    var appLocation = _a.appLocation, currentBoostSelectionToken = _a.currentBoostSelectionToken, currentBoostToken = _a.currentBoostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Remove Start",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Remove",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_selection_token: currentBoostSelectionToken !== undefined && currentBoostSelectionToken !== null ? currentBoostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_token: currentBoostToken !== undefined && currentBoostToken !== null ? currentBoostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostRemoveCompleteEvent
 *
 * @deprecated Use BoostRemoveSelect instead.
 */
export var BoostRemoveComplete = function (_a) {
    var appLocation = _a.appLocation, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Remove Complete",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Remove",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostRemoveSelectEvent
 */
export var BoostRemoveSelect = function (_a) {
    var appLocation = _a.appLocation, origin = _a.origin, currentBoostSelectionToken = _a.currentBoostSelectionToken, currentBoostToken = _a.currentBoostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, boostFlowToken = _a.boostFlowToken, referrerFlowToken = _a.referrerFlowToken, appPresentation = _a.appPresentation, row = _a.row, column = _a.column;
    return ({
        name: "Boost Remove Select",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Remove",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_selection_token: currentBoostSelectionToken !== undefined && currentBoostSelectionToken !== null ? currentBoostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_token: currentBoostToken !== undefined && currentBoostToken !== null ? currentBoostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_presentation: appPresentation !== undefined && appPresentation !== null ? appPresentation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSwapStartEvent
 *
 * @deprecated Use Add events with `current_boost_token` instead.
 */
export var BoostSwapStart = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, currentBoostSelectionToken = _a.currentBoostSelectionToken, currentBoostToken = _a.currentBoostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Swap Start",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Swap",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_selection_token: currentBoostSelectionToken !== undefined && currentBoostSelectionToken !== null ? currentBoostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_token: currentBoostToken !== undefined && currentBoostToken !== null ? currentBoostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSwapCompleteEvent
 *
 * @deprecated Use Add events with `current_boost_token` instead.
 */
export var BoostSwapComplete = function (_a) {
    var appLocation = _a.appLocation, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Boost Swap Complete",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Swap",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSwapSelectEvent
 *
 * @deprecated Use Add events with `current_boost_token` instead.
 */
export var BoostSwapSelect = function (_a) {
    var appLocation = _a.appLocation, origin = _a.origin, boostToken = _a.boostToken, currentBoostSelectionToken = _a.currentBoostSelectionToken, currentBoostToken = _a.currentBoostToken, flowToken = _a.flowToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, boostFlowToken = _a.boostFlowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Boost Swap Select",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Swap",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_selection_token: currentBoostSelectionToken !== undefined && currentBoostSelectionToken !== null ? currentBoostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_boost_token: currentBoostToken !== undefined && currentBoostToken !== null ? currentBoostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostUnlockStartEvent
 */
export var BoostUnlockStart = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken;
    return ({
        name: "Boost Unlock Start",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Unlock",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostUnlockAdvanceUnlockProgressEvent
 */
export var BoostUnlockAdvanceUnlockProgress = function (_a) {
    var boostSelectionToken = _a.boostSelectionToken, boostToken = _a.boostToken, cardTransactionToken = _a.cardTransactionToken;
    return ({
        name: "Boost Unlock AdvanceUnlockProgress",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Unlock",
            boost_selection_token: boostSelectionToken !== undefined && boostSelectionToken !== null ? boostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            card_transaction_token: cardTransactionToken !== undefined && cardTransactionToken !== null ? cardTransactionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostUnlockCompleteEvent
 */
export var BoostUnlockComplete = function (_a) {
    var boostSelectionToken = _a.boostSelectionToken, boostToken = _a.boostToken;
    return ({
        name: "Boost Unlock Complete",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Unlock",
            boost_selection_token: boostSelectionToken !== undefined && boostSelectionToken !== null ? boostSelectionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostViewOpenCarouselEvent
 */
export var BoostViewOpenCarousel = function (_a) {
    var appLocation = _a.appLocation, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Boost View OpenCarousel",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostViewOpenTileEvent
 */
export var BoostViewOpenTile = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, referrerFlowToken = _a.referrerFlowToken, appPresentation = _a.appPresentation, row = _a.row, column = _a.column, origin = _a.origin, searchOrigin = _a.searchOrigin;
    return ({
        name: "Boost View OpenTile",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_presentation: appPresentation !== undefined && appPresentation !== null ? appPresentation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_origin: searchOrigin !== undefined && searchOrigin !== null ? searchOrigin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostViewOpenDetailsEvent
 */
export var BoostViewOpenDetails = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, referrerFlowToken = _a.referrerFlowToken, boostFlowToken = _a.boostFlowToken, appPresentation = _a.appPresentation, row = _a.row, column = _a.column;
    return ({
        name: "Boost View OpenDetails",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_presentation: appPresentation !== undefined && appPresentation !== null ? appPresentation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostViewOpenAffiliateConfirmationEvent
 */
export var BoostViewOpenAffiliateConfirmation = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, referrerFlowToken = _a.referrerFlowToken, boostFlowToken = _a.boostFlowToken;
    return ({
        name: "Boost View OpenAffiliateConfirmation",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostViewCloseAffiliateConfirmationEvent
 */
export var BoostViewCloseAffiliateConfirmation = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, referrerFlowToken = _a.referrerFlowToken, boostFlowToken = _a.boostFlowToken;
    return ({
        name: "Boost View CloseAffiliateConfirmation",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSearchEnterTextEvent
 */
export var BoostSearchEnterText = function (_a) {
    var appLocation = _a.appLocation, referrerFlowToken = _a.referrerFlowToken, count = _a.count, searchText = _a.searchText;
    return ({
        name: "Boost Search EnterText",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Search",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSearchOpenTileEvent
 */
export var BoostSearchOpenTile = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, referrerFlowToken = _a.referrerFlowToken, searchText = _a.searchText, row = _a.row, column = _a.column;
    return ({
        name: "Boost Search OpenTile",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Search",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostSearchOpenDetailsEvent
 */
export var BoostSearchOpenDetails = function (_a) {
    var appLocation = _a.appLocation, boostToken = _a.boostToken, referrerFlowToken = _a.referrerFlowToken, boostFlowToken = _a.boostFlowToken, searchText = _a.searchText;
    return ({
        name: "Boost Search OpenDetails",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Search",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BoostShopStartEvent
 */
export var BoostShopStart = function (_a) {
    var appLocation = _a.appLocation, origin = _a.origin, boostToken = _a.boostToken, referrerFlowToken = _a.referrerFlowToken, boostFlowToken = _a.boostFlowToken;
    return ({
        name: "Boost Shop Start",
        parameters: {
            cdf_entity: "Boost",
            cdf_action: "Shop",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_token: boostToken !== undefined && boostToken !== null ? boostToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            boost_flow_token: boostFlowToken !== undefined && boostFlowToken !== null ? boostFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
